import "./TradingIdeasEditControlComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {Observable, ReplaySubject, Scheduler} from "rxjs";
import {StateService} from "@uirouter/core";
import {TradingIdeasViewStore} from "../../../store/TradingIdeasViewStore";
import {StrategyService} from "../../../../types/StrategyService";
import {TradeIdeasViewModel} from "../../../models/TradeIdeasViewModel";

export const TradingIdeasEditControl = "tfTradingIdeasEditControl";

export function tradingIdeasEditControl(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/controls/edit/TradingIdeasEditControlComponent.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: TradingIdeasEditControlComponentController
    };
}

export class TradingIdeasEditControlComponentController implements IOnInit, IOnDestroy {

    /** @Input */
    public readonly store: TradingIdeasViewStore;

    private readonly editIdea$ = new ReplaySubject<boolean>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly strategyService: StrategyService,
                       private readonly $state: StateService) {
    }

    public $onInit(): void {
        this.watchEditIdea();
    }

    private watchEditIdea() {
        this.editIdea$
            .observeOn(Scheduler.async)
            .takeUntil(this.destroyed$)
            .throttleTime(5000)
            .withLatestFrom(this.store.currentModel)
            .map(([_, model]) => model)
            .switchMap((model) => this.createStrategyFromModel(model))
            .subscribe((strategyId) => this.$state.go("strategy", {activeStrategy: strategyId}));
    }

    private createStrategyFromModel(model: TradeIdeasViewModel): Observable<number> {
        const result = this.strategyService.createStrategy(model.idea.underlying,
                                                           model.trades(),
                                                           true,
                                                           model.strategyName(),
                                                           "",
                                                           model.riskAmount.currentLots);
        // TODO We should probably tell them something went wrong...
        return Observable.fromPromise(result)
                         .map((strategy) => strategy.id)
                         .catch((err) => Observable.empty<number>());
    }

    public editIdea() {
        this.editIdea$.next(true);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
